// disable auto-story
import Script from 'next/script';
import useGtmId from './useGtmId';

export interface GtmArgs {
  data: object;
}

function Gtm({ data }: GtmArgs) {
  const gtmData = data ? data : { description: 'GTM data is missing.' };
  const gtmId = useGtmId();

  if (!gtmId) return null;

  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(${JSON.stringify(gtmData)});`,
        }}
        id="data-layer-script"
        strategy="afterInteractive"
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${gtmId}');`,
        }}
        id="google-tag-manager-script"
        strategy="afterInteractive"
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display: none; visibility: hidden;"></iframe>`,
        }}
      />
    </>
  );
}

export default Gtm;
